import { Typography } from "@mui/material";

export const Logo = () => <Typography variant="h6">♻️ SmartWaste</Typography>;
